import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "..";

const requestBaseQuery = baseQuery("products", "*, wishlist:wishlist(*)");

export const productsApi = createApi({
  reducerPath: "products",
  baseQuery: requestBaseQuery,
  tagTypes: ["product"],
  endpoints: (builder) => ({
    getLatestProducts: builder.query({
      query: (params) => ({
        type: "GET",
        gte: { created_at: params.startDate },
        lte: { created_at: params.endDate },
      }),
      providesTags: () => [{ type: "product" }],
    }),
    getProducts: builder.query({
      query: ({ filter, offset, pageLimit }) => ({
        type: "GET",
        filters: filter ?? undefined,
        offset: offset ?? 0,
        limit: pageLimit ?? 10,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "product", id })), // Provide individual product tags
              { type: "product", id: "LIST" }, // Provide LIST tag for the whole product list
            ]
          : [{ type: "product", id: "LIST" }],
    }),
    getAllProducts: builder.query({
      query: ({ offset, pageLimit }) => ({
        type: "GET",
        offset: offset ?? 0,
        limit: pageLimit ?? 10,
      }),
      providesTags: () => [{ type: "product" }],
    }),
    addProduct: builder.mutation({
      query: (productDetails) => ({ type: "POST", data: productDetails }),
      invalidatesTags: [{ type: "product", id: "LIST" }],
    }),
    updateProduct: builder.mutation({
      query: (productDetails) => ({
        type: "PATCH",
        data: productDetails,
        id: productDetails.id,
      }),
      invalidatesTags: ["product"],
    }),
    deleteProduct: builder.mutation({
      query: (id) => ({ type: "DELETE", id }),
      invalidatesTags: [{ type: "product", id: "LIST" }],
    }),
    getProductsOnSale: builder.query({
      query: () => ({
        type: "GET",
        filter: "sale_price.not.is.true"
      }),
      providesTags: () => [{ type: "product" }],
    }),
  }),
});

export const {
  useGetLatestProductsQuery,
  useGetProductsQuery,
  useGetAllProductsQuery,
  useAddProductMutation,
  useDeleteProductMutation,
  useUpdateProductMutation,
  useGetProductsOnSaleQuery
} = productsApi;
